import { Row, Space, Button } from 'antd'
import { ModalFooterProps } from './types'
import { useWatch } from 'antd/lib/form/Form'

function ModalFooter<T>({ form, mutating, onClose }: ModalFooterProps<T>) {
  const description = useWatch('description', form)
  return (
    <Row justify="end">
      <Space>
        <Button onClick={() => onClose()}>Cancel</Button>
        <Button
          onClick={() => {
            form.setFieldValue('submit', false)
            form.submit()
          }}
          loading={mutating}
          disabled={mutating}
        >
          Save as Draft
        </Button>
        <Button
          onClick={() => {
            form.setFieldValue('submit', true)
            form.submit()
          }}
          type="primary"
          disabled={mutating || !description}
          loading={mutating}
        >
          Submit
        </Button>
      </Space>
    </Row>
  )
}

export default ModalFooter
